/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Outline_LabelInputs */



/**
* | output |
* | --- |
* | "Outline" |
*
* @param {Styles_Outline_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_outline_label = /** @type {((inputs?: Styles_Outline_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Outline_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Contour")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gliederung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Schema")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Контур")
	if (locale === "es") return /** @type {LocalizedString} */ ("Describir")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("大纲")
	if (locale === "ja") return /** @type {LocalizedString} */ ("概要")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रूपरेखा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Contorno")
	return /** @type {LocalizedString} */ ("Outline")
});